import getGlobalFailedTnx from "../../ajax/actions/failed-site-transactions/globalFailed-get";
import store from "../../Store";

export function toggleFailedSiteFilter(e) {
  return function (dispatch) {
    let { name, value } = e.target;

    dispatch({
      type: "TOGGLE-FAILED-SITE-FILTER",
      name,
      value,
    });

    store.dispatch(getGlobalFailedTnx(true));
  };
}

export function toggleFailedSiteModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-FAILED-SITE-MODAL" });
  };
}

export function toggleFailedSiteStatusModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-FAILED-SITE-STATUS-MODAL" });
  };
}

export function resetFilterParams() {
  return function (dispatch) {
    dispatch({ type: "RESET-FILTER-PARAMS" });
  };
}
